<template>
    <div class="modal">
        <div class="modal-content">
            <div>
                KOJA ROLA SE PRINTA:
                <select v-model="selectedRole">
                    <option v-for="role in roles" v-bind:value="role" v-bind:key="role">
                        {{role}}
                    </option>
                </select>
            </div>
            <div class="modal-footer">
                <button type="button" v-on:click="$emit('confirm', selectedRole)">SPREMI</button>
                <button type="button" v-on:click="$emit('cancel')">ODUSTANI</button>
            </div>
        </div>
        <a aria-label="Zatvori popup" class="close-modal" v-on:click="$emit('cancel')"></a>
    </div>
</template>

<script>
    export default {
        name: 'BulkPrintModal',
        data() {
            return {
                selectedRole: "Guest"
            }
        },
        props: {
            roles: Array
        }
    }
</script>